import { IQueryCommandOptions } from '@llws/dynamic-router-utils';
import { ISubscriptions } from '@llws/lift-entity-interfaces';
import { StoreBaseImplementationV2 } from '@/shared/classes/store-base-implementation-v2';
import { TPremiumReportingSubscription } from '@/shared/factory/new-premium-reporting-subscription';
import { IAction, IStateStrict } from '@/shared/interfaces/store-base';
import { adminRequest } from '@/shared/request-configs/admin-request';

// Base store configuration
const adminGatewayResourcePath: string = '/billing-api/lift_subscriptions';
const listViewName: string = '';
const showLogging: boolean = false;

const defaultGetListFilters: IQueryCommandOptions = {
  relations: [
    {
      path: 'baseSubcriptions',
      alias: 'bs',
    },
  ],
};

const defaultGetSingleFilters: IQueryCommandOptions = {
  relations: [
    {
      path: 'baseSubcriptions',
      alias: 'bs',
    },
  ],
};

// Instantiate the base store with the params
const base = new StoreBaseImplementationV2<Partial<TPremiumReportingSubscription>>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

// Extend StoreBaseImplementation object to add custom state/getters/mutations/actions.
export default {
  namespaced: base.namespaced,

  state: {
    ...base.state,
  },

  getters: {
    ...base.getters,
  },

  mutations: {
    ...base.mutations,
  },

  actions: {
    ...base.actions,
    async saveSubscription(_ctx: IAction<IStateStrict<TPremiumReportingSubscription>>, payload: TPremiumReportingSubscription) {
      const result = await adminRequest.post(`${adminGatewayResourcePath}`, payload);
      return result.data;
    },
  },
};
